import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'av-loading-item',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './av-loading-item.component.html',
  styleUrls: ['./av-loading-item.component.scss'],
})
export class AvLoadingItemComponent {
  readonly icon = input<string>('autorenew');
  readonly textKey = input<string>('shared.general.labels.loading');
}
